(function () {

  /* Only run on the search results app */
  if (!window.location.pathname.startsWith('/apps/search-result')) {
    return;
  }

  const productCache = new Map();
  let observerTimer = null;

  /*
   * Get Shopify product information.
   * We use the product tags to determine whether the item
   * is Tower Garden / TG Seeds.
   */
  async function getProductInfo(productUrl) {

    if (productCache.has(productUrl)) {
      return productCache.get(productUrl);
    }

    const request = (async function () {

      try {

        const jsonResponse = await fetch(productUrl + '.js', {
          credentials: 'same-origin'
        });

        if (!jsonResponse.ok) {
          throw new Error('Could not load product JSON');
        }

        const product = await jsonResponse.json();

        let tags = product.tags || [];

        if (!Array.isArray(tags)) {
          tags = String(tags)
            .split(',')
            .map(function (tag) {
              return tag.trim();
            });
        }

        const normalizedTags = tags.map(function (tag) {
          return String(tag).trim().toLowerCase();
        });

        const isTowerGarden =
          normalizedTags.includes('tower garden') ||
          normalizedTags.includes('tg seeds');

        let affiliateUrl = '';
        let towerTitle = product.title || '';
        let towerImage = product.featured_image || '';

        /*
         * The Shopify Ajax product JSON doesn't expose your
         * custom.tower_garden_url metafield.
         *
         * If this is a Tower Garden product, load its product page
         * and look for the Buy Now link you already create there.
         */
        if (isTowerGarden) {

          try {

            const pageResponse = await fetch(productUrl, {
              credentials: 'same-origin'
            });

            if (pageResponse.ok) {

              const html = await pageResponse.text();
              const doc = new DOMParser().parseFromString(
                html,
                'text/html'
              );

              const towerLink = doc.querySelector(
                '.tower-garden-buy-now[data-tower-garden-url], ' +
                '.tower-garden-buy-now[href]'
              );

              if (towerLink) {

                affiliateUrl =
                  towerLink.getAttribute('data-tower-garden-url') ||
                  towerLink.getAttribute('href') ||
                  '';

                towerTitle =
                  towerLink.getAttribute('data-tower-garden-title') ||
                  towerTitle;

                towerImage =
                  towerLink.getAttribute('data-tower-garden-image') ||
                  towerImage;
              }
            }

          } catch (error) {
            console.warn(
              'Living Towers: could not find Tower Garden affiliate URL',
              productUrl,
              error
            );
          }
        }

        return {
          product: product,
          isTowerGarden: isTowerGarden,
          affiliateUrl: affiliateUrl,
          towerTitle: towerTitle,
          towerImage: towerImage
        };

      } catch (error) {

        console.warn(
          'Living Towers: could not inspect search product',
          productUrl,
          error
        );

        return null;
      }

    })();

    productCache.set(productUrl, request);

    return request;
  }


  /*
   * Read the arguments from the search app's existing
   * ts7AddToCartPro() call.
   */
  function parseSearchButton(button) {

    const onclick = button.getAttribute('onclick') || '';

    const match = onclick.match(
      /ts7AddToCartPro\s*\(\s*this\s*,\s*(\d+)\s*,\s*'([^']*)'\s*,\s*'([^']*)'\s*,\s*'([^']*)'\s*,\s*'([^']*)'\s*,\s*'([^']*)'\s*\)/
    );

    if (!match) {
      return null;
    }

    return {
      productId: match[1],
      location: match[2],
      colorDiv: match[3],
      optionId: match[4],
      productUrl: match[5],
      originalQty: match[6]
    };
  }


  /*
   * NORMAL PRODUCTS
   *
   * Add:
   *   -  1  +
   *
   * while continuing to use the search app's own
   * ts7AddToCartPro() function.
   */
  function makeQuantityControl(button, args) {

    const tooltip = button.closest('.ts7-show-add-to-cart');

    if (!tooltip) {
      return;
    }

    tooltip.classList.add('lt-search-enhanced');

    const controls = document.createElement('div');
    controls.className = 'lt-search-cart-controls';

    const qtyBox = document.createElement('div');
    qtyBox.className = 'lt-search-qty';

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.innerHTML = '&minus;';
    minus.setAttribute('aria-label', 'Decrease quantity');

    const qty = document.createElement('input');
    qty.type = 'number';
    qty.min = '1';
    qty.step = '1';
    qty.value = '1';
    qty.setAttribute('aria-label', 'Quantity');

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.innerHTML = '+';
    plus.setAttribute('aria-label', 'Increase quantity');

    minus.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const current = parseInt(qty.value, 10) || 1;

      qty.value = Math.max(1, current - 1);
    });

    plus.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const current = parseInt(qty.value, 10) || 1;

      qty.value = current + 1;
    });

    qty.addEventListener('change', function () {

      let value = parseInt(qty.value, 10);

      if (!value || value < 1) {
        value = 1;
      }

      qty.value = value;
    });

    qtyBox.appendChild(minus);
    qtyBox.appendChild(qty);
    qtyBox.appendChild(plus);

    /*
     * Remove the app's fixed inline onclick.
     * We call exactly the same function ourselves,
     * except with the customer's selected quantity.
     */
    button.removeAttribute('onclick');

    button.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      let quantity = parseInt(qty.value, 10) || 1;

      quantity = Math.max(1, quantity);

      if (typeof window.ts7AddToCartPro === 'function') {

        window.ts7AddToCartPro(
          button,
          Number(args.productId),
          args.location,
          args.colorDiv,
          args.optionId,
          args.productUrl,
          String(quantity)
        );

      } else {

        console.error(
          'Living Towers: ts7AddToCartPro was not found.'
        );
      }
    });

    /*
     * Move the existing app Add to Cart button into
     * our new quantity/button row.
     */
    tooltip.insertBefore(controls, button);

    controls.appendChild(qtyBox);
    controls.appendChild(button);
  }


  /*
   * TOWER GARDEN PRODUCTS
   *
   * Remove the search app Add to Cart action completely
   * and replace it with Buy Now.
   */
  function makeTowerGardenButton(button, args, info) {

    const tooltip = button.closest('.ts7-show-add-to-cart');

    if (!tooltip) {
      return;
    }

    tooltip.classList.add('lt-search-enhanced');

    const link = document.createElement('a');

    /*
     * If for some reason the metafield URL can't be found,
     * send them to the product page instead.
     *
     * Most importantly: DO NOT leave Add to Cart active.
     */
    link.href = info.affiliateUrl || args.productUrl;

    link.rel = 'noopener sponsored';

    /*
     * This allows the link to behave like your existing
     * Tower Garden Buy Now buttons.
     */
    link.className =
      'ts7-result-btn ts7-outline-btn ts7-btn ' +
      'tower-garden-buy-now lt-search-tower-link';

    if (info.affiliateUrl) {
      link.setAttribute(
        'data-tower-garden-url',
        info.affiliateUrl
      );
    }

    if (info.towerTitle) {
      link.setAttribute(
        'data-tower-garden-title',
        info.towerTitle
      );
    }

    if (info.towerImage) {
      link.setAttribute(
        'data-tower-garden-image',
        info.towerImage
      );
    }

    link.setAttribute(
      'aria-label',
      'Buy ' + (info.towerTitle || 'Tower Garden')
    );

    /*
     * If your existing Tower Garden modal doesn't
     * intercept the dynamically-created link,
     * it will still safely open the affiliate URL.
     */
    link.target = '_blank';

    link.innerHTML = '<span>Buy Now</span>';

    button.replaceWith(link);
  }


  /*
   * Process every Add to Cart button generated by
   * the search app.
   */
  async function processSearchButtons() {

    const buttons = document.querySelectorAll(
      '.ts7_result-addToCart:not([data-lt-processed])'
    );

    for (const button of buttons) {

      /*
       * Mark immediately so MutationObserver doesn't
       * process the same button repeatedly.
       */
      button.setAttribute(
        'data-lt-processed',
        'processing'
      );

      const args = parseSearchButton(button);

      if (!args || !args.productUrl) {

        button.setAttribute(
          'data-lt-processed',
          'failed'
        );

        continue;
      }

      const info = await getProductInfo(
        args.productUrl
      );

      if (!info) {

        button.setAttribute(
          'data-lt-processed',
          'failed'
        );

        continue;
      }

      if (info.isTowerGarden) {

        makeTowerGardenButton(
          button,
          args,
          info
        );

      } else {

        makeQuantityControl(
          button,
          args
        );
      }

      button.setAttribute(
        'data-lt-processed',
        'true'
      );
    }
  }


  /*
   * Search results are loaded dynamically,
   * so run once now and then watch for changes.
   */
  processSearchButtons();

  const observer = new MutationObserver(function () {

    clearTimeout(observerTimer);

    observerTimer = setTimeout(function () {
      processSearchButtons();
    }, 100);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
